import { immerable } from "immer";
import BuildingMeasures from "./building-measures.ts";
import StoreyMeasures from "./storey-measures.ts";
import Measure from "./measure.ts";

class ProjectMeasures {
    [immerable] = true;

    buildings: BuildingMeasures[] = [];

    getBuilding(id: string) {
        return this.buildings.find(b => b.id === id);
    }

    getStorey(buildingIdOrStoreyId: string, storeyId?: string) {
        if (storeyId) {
            return this.getBuilding(buildingIdOrStoreyId)?.storeys.find(s => s.id === storeyId);
        }
        return this.buildings.flatMap(b => b.storeys).find(s => s.id === buildingIdOrStoreyId);
    }

    getBuildingAndStoreyFromStoreyId(storeyId: string): { building: BuildingMeasures, storey: StoreyMeasures } | undefined {
        return this.buildings.reduce<{ building: BuildingMeasures, storey: StoreyMeasures } | undefined>
            ((found, building) => {
                if (found) return found;

                const match = building.storeys.find(s => s.id === storeyId);
                return match ? { building, storey: match } : undefined;
            }, undefined);
    }

    editMeasure(buildingId: string, storeyId: string, measureId: string, measure: Measure): void {
        const building = this.getBuilding(buildingId);
        if (building == null) return;

        const storey = building.getStorey(storeyId);
        if (storey == null) return;

        storey.editMeasure(measureId, measure);
    }
}

export default ProjectMeasures;